// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFileTypeDto } from './IFileTypeDto';
import {
    IFileTypeDtoFromJSON,
    IFileTypeDtoFromJSONTyped,
    IFileTypeDtoToJSON,
    IFileTypeDtoToJSONTyped,
} from './IFileTypeDto';

/**
 * 
 * @export
 * @interface IFileSearchInfoDto
 */
export interface IFileSearchInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IFileSearchInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IFileSearchInfoDto
     */
    name?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof IFileSearchInfoDto
     */
    partners_names?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof IFileSearchInfoDto
     */
    employers_names?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof IFileSearchInfoDto
     */
    uploaded_by?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileSearchInfoDto
     */
    upload_way?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileSearchInfoDto
     */
    file_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileSearchInfoDto
     */
    origin_file_path?: string;
    /**
     * 
     * @type {IFileTypeDto}
     * @memberof IFileSearchInfoDto
     */
    file_types?: IFileTypeDto;
    /**
     * 
     * @type {Date}
     * @memberof IFileSearchInfoDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IFileSearchInfoDto
     */
    processed_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IFileSearchInfoDto
     */
    records_errors?: number;
}

/**
 * Check if a given object implements the IFileSearchInfoDto interface.
 */
export function instanceOfIFileSearchInfoDto(value: object): value is IFileSearchInfoDto {
    return true;
}

export function IFileSearchInfoDtoFromJSON(json: any): IFileSearchInfoDto {
    return IFileSearchInfoDtoFromJSONTyped(json, false);
}

export function IFileSearchInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFileSearchInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'partners_names': json['partners_names'] == null ? undefined : new Set(json['partners_names']),
        'employers_names': json['employers_names'] == null ? undefined : new Set(json['employers_names']),
        'uploaded_by': json['uploaded_by'] == null ? undefined : json['uploaded_by'],
        'upload_way': json['upload_way'] == null ? undefined : json['upload_way'],
        'file_path': json['file_path'] == null ? undefined : json['file_path'],
        'origin_file_path': json['origin_file_path'] == null ? undefined : json['origin_file_path'],
        'file_types': json['file_types'] == null ? undefined : IFileTypeDtoFromJSON(json['file_types']),
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'processed_at': json['processed_at'] == null ? undefined : (new Date(json['processed_at'])),
        'records_errors': json['records_errors'] == null ? undefined : json['records_errors'],
    };
}

export function IFileSearchInfoDtoToJSON(json: any): IFileSearchInfoDto {
    return IFileSearchInfoDtoToJSONTyped(json, false);
}

export function IFileSearchInfoDtoToJSONTyped(value?: IFileSearchInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'partners_names': value['partners_names'] == null ? undefined : Array.from(value['partners_names'] as Set<any>),
        'employers_names': value['employers_names'] == null ? undefined : Array.from(value['employers_names'] as Set<any>),
        'uploaded_by': value['uploaded_by'],
        'upload_way': value['upload_way'],
        'file_path': value['file_path'],
        'origin_file_path': value['origin_file_path'],
        'file_types': IFileTypeDtoToJSON(value['file_types']),
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'processed_at': value['processed_at'] == null ? undefined : ((value['processed_at']).toISOString()),
        'records_errors': value['records_errors'],
    };
}

